import React from 'react';
import { Wrench } from 'lucide-react';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export default function Logo({ className = '', size = 'lg' }: LogoProps) {
  const sizes = {
    sm: {
      icon: 'w-5 h-5',
      iconContainer: 'p-1',
      text: 'text-xl'
    },
    md: {
      icon: 'w-6 h-6',
      iconContainer: 'p-1.5',
      text: 'text-2xl'
    },
    lg: {
      icon: 'w-6 h-6',
      iconContainer: 'p-1.5',
      text: 'text-3xl'
    }
  };

  const currentSize = sizes[size];

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className={`bg-gradient-to-r from-blue-600 to-blue-500 rounded-lg ${currentSize.iconContainer} shadow-md`}>
        <Wrench className={`${currentSize.icon} text-white`} />
      </div>
      <span className={`font-extrabold ${currentSize.text} text-gray-900 tracking-tight`}>
        <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-blue-500">b</span>
        tool
        <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-blue-600">me</span>
      </span>
    </div>
  );
}